import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="ob-container py-32" data-testid="not-found">
      <div className="ob-eyebrow mb-4">404</div>
      <h1 className="ob-h1">Page not found.</h1>
      <p className="ob-lead mt-6">The page you were looking for doesn't exist or has moved.</p>
      <div className="mt-10">
        <Link to="/" className="ob-btn ob-btn-primary">Back to home</Link>
      </div>
    </div>
  );
}
